import React, { useEffect } from "react";
import { Button } from "bootstrap-4-react/lib/components";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { checkPermission } from "../../config/utils";
import { featureSubmodule, settings, SUBF_DEFAULTSETTINGS } from "../../constant";
import "../setup/setup.css";

const tileList = [
    {
        name: "Service Configuration",
        description: "Carrier services enabled by default for a new seller.",
        subtitle: "Opens Manage Carriers \u203A Default Settings",
        icon: "fa fa-ship",
        color: "#0000ff69",
        path: "/manage-carriers?tab=default",
    },
    {
        name: "Margin Configuration",
        description: "Margins applied by default to a new seller's carrier services.",
        subtitle: "Opens Margin Configuration \u203A Default Settings",
        icon: "fa fa-percent",
        color: "#0000ff69",
        path: "/margin-configuration?tab=default",
    },
    {
        name: "Dropship Margin Configuration",
        description: "Global default margin applied to dropship orders.",
        subtitle: "Opens Dropship Margin Config \u203A Global Default Margin",
        icon: "fa fa-exchange",
        color: "#28a745",
        path: "/dropship-margin-config?tab=default",
    },
    {
        name: "Wallet Threshold",
        description: "Minimum wallet balance a new seller must hold to ship.",
        subtitle: "Opens Wallet Threshold \u203A Default Settings",
        icon: "fa fa-usd",
        color: "#4BBBD3",
        path: "/wallet-threshold-defaults",
    },
    {
        name: "Units, Time Zone & Date Format",
        description: "Measurement units, time zone and date display for new sellers.",
        subtitle: "Opens Configuration \u203A Default Settings",
        icon: "fa fa-clock-o",
        color: "#0000ff69",
        path: "/configuration-defaults",
    },
];

export default function DefaultSettingsHub(props) {
    const navigate = useNavigate();
    const userDetails = useSelector((state) => state.auth.user);
    const employeePermissions = useSelector((state) => state?.sidebar?.employeePermissions);
    const permissionEmployees = props?.employeePermissions || employeePermissions;

    const hasAccess = userDetails?.Value?.isSuperAdmin
        && checkPermission(settings, SUBF_DEFAULTSETTINGS, '', featureSubmodule, permissionEmployees);

    useEffect(() => {
        if (userDetails?.Value && !hasAccess) {
            navigate("/setting");
        }
    }, [userDetails, hasAccess, navigate]);

    if (!hasAccess) return null;

    return (
        <main>
            <div className="main__container">
                <div className="main__tile_heading cus-btn-include-sec">
                    Default Settings
                    <div className="top_right_button_container">
                        <Button
                            className="cus-primary-transparent-btn"
                            onClick={() => navigate("/setting")}
                        >
                            Back
                        </Button>
                    </div>
                </div>

                <div className="container-fluid">
                    <div className="cus-page-content-sec">
                        <div className="mb-3 pl-3 pr-3">
                            <div className="alert alert-info" role="alert" style={{ fontSize: '13px' }}>
                                <i className="fa fa-info-circle me-2 pr-1" aria-hidden="true"></i>Default settings apply only to newly created seller accounts. Existing seller configurations are not affected.
                            </div>
                        </div>
                        <div className="content-container">
                            <div className="cards setup-container">
                                {tileList.map((tile) => (
                                    <button
                                        key={tile.name}
                                        type="button"
                                        className="setup-card"
                                        onClick={() => navigate(tile.path)}
                                    >
                                        <div className="icon">
                                            <i className={tile.icon} />
                                        </div>
                                        <div className="txt-name">{tile.name}</div>
                                        {tile.description && (
                                            <div className="txt-desc" style={{ fontSize: '12px', color: '#6c757d', marginTop: '4px' }}>
                                                {tile.description}
                                            </div>
                                        )}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}

DefaultSettingsHub.propTypes = {
    employeePermissions: PropTypes.array,
};
